var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92834 4.624L5.63234 3.92L9.72834 8L5.63234 12.08L4.92834 11.376L7.80834 8.496H0.944336V7.504H7.80834L4.92834 4.624ZM10.3843 2H15.0563V14H10.3843V2ZM2.06434 0.992V3.504H1.05634V0.992C1.05634 0.714667 1.15234 0.48 1.34434 0.288C1.547 0.096 1.787 0 2.06434 0H16.0643C16.3417 0 16.5763 0.096 16.7683 0.288C16.9603 0.48 17.0563 0.714667 17.0563 0.992V15.008C17.0563 15.2747 16.9603 15.504 16.7683 15.696C16.5763 15.8987 16.3417 16 16.0643 16H2.06434C1.787 16 1.547 15.904 1.34434 15.712C1.15234 15.52 1.05634 15.2853 1.05634 15.008V12.496H2.06434V15.008H16.0643V0.992H2.06434Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.62c1b65383e721e9706f386b2a4bd2f7.svg";
export { ForwardRef as ReactComponent };